export default __webpack_public_path__ + "static/media/platform.6a51c961.svg";